import { keyframes } from 'styled-components/macro';

export const scaleIn = keyframes`
  from { transform: scale(0); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
`;
